var map = {
	"./Avatar.vue": "df3a",
	"./Block.vue": "2efe",
	"./Button.vue": "2a7d",
	"./Button/Migrate.vue": "f1c6",
	"./Button/Unlock.vue": "ca8a",
	"./Chart.vue": "0292",
	"./Container.vue": "185a",
	"./Filters.vue": "35ce",
	"./Form/Crp.vue": "be6f",
	"./Icon.vue": "cdae",
	"./Icon/CheckCircle.vue": "ca97",
	"./Icon/ChevronDown.vue": "5a64",
	"./Icon/ChevronUp.vue": "61d9",
	"./List/Loading.vue": "26f0",
	"./List/Pool.vue": "be3b",
	"./List/Pools.vue": "8160",
	"./List/Token.vue": "be55",
	"./List/Tokens.vue": "29ed",
	"./Message/Error.vue": "66a4",
	"./Message/SimilarPools.vue": "a0f9",
	"./Message/Slippage.vue": "9efc",
	"./Message/Warning.vue": "6d80",
	"./Message/WarningRateChange.vue": "5b50",
	"./Message/WarningToken.vue": "47e9",
	"./Migration/Stats.vue": "9ed9",
	"./Migration/Wallet.vue": "3d03",
	"./Modal/About.vue": "8188",
	"./Modal/Account.vue": "34ec",
	"./Modal/Activity.vue": "68b3",
	"./Modal/AddLiquidity.vue": "3960",
	"./Modal/CustomToken.vue": "23a7",
	"./Modal/EditCap.vue": "66b4",
	"./Modal/EditController.vue": "7740",
	"./Modal/EditPublicSwap.vue": "1a55",
	"./Modal/EditSwapFee.vue": "91bc",
	"./Modal/EditTokens.vue": "2164",
	"./Modal/EditWeights.vue": "d910",
	"./Modal/EditWeightsGradually.vue": "c5cc",
	"./Modal/ManageWhitelist.vue": "2ba2",
	"./Modal/PoolCreation.vue": "16c6",
	"./Modal/RemoveLiquidity.vue": "03fe",
	"./Modal/SelectToken.vue": "c8e2",
	"./Modal/Wrapper.vue": "ba88",
	"./MyPoolShares.vue": "0fec",
	"./Nav.vue": "216c",
	"./Notifications.vue": "e985",
	"./Page.vue": "9973",
	"./Pie.vue": "4336",
	"./PoolBoxes.vue": "ad9b",
	"./PoolHeader.vue": "a7ff",
	"./PoolOverview.vue": "63da",
	"./Progress.vue": "ad18",
	"./Search.vue": "c106",
	"./Sidebar.vue": "5ea5",
	"./SingleMultiToggle.vue": "23b0",
	"./Sticky.vue": "c6f5",
	"./Tabs.vue": "b50c",
	"./Toggle.vue": "ae48",
	"./Token.vue": "837d",
	"./Topnav.vue": "2fc9",
	"./Ui/Button.vue": "64c4",
	"./Ui/Checkbox.vue": "fd36",
	"./Ui/Counter.vue": "2fbf",
	"./Ui/Label.vue": "8af8",
	"./Ui/Loading.vue": "d1e9",
	"./Ui/Modal.vue": "ae01",
	"./Ui/Modal/Form.vue": "8540",
	"./Ui/Num.vue": "c847",
	"./Ui/Pie.vue": "43f9",
	"./Ui/Radio.vue": "3159",
	"./Ui/Table.vue": "810f",
	"./Ui/Table/Th.vue": "a022",
	"./Ui/Table/Tr.vue": "c152"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4daf";